import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CandidateWorkflowFeedbackStep {
    countLabel = '';
    feedbackStepHref = '';
    workflowStep = 'Feedback';
    feedbackLabel = 'EMPLOYER_FEEDBACK';

    /* @ngInject */
    constructor($filter, $state) {
        this.$filter = $filter;
        this.$state = $state;
    }

    $onChanges() {
        const { counters } = this;

        this.countLabel = this.getCountLabel(counters);
        this.feedbackStepHref = this.getFeedbackStepHref();
    }

    getCountLabel({
        feedbackStatusExist = false,
        allFeedBackWorkflows = 0,
        feedbackAcceptedCount = 0,
        readyForSendFeedbackCount = 0,
        feedbackPendingCount = 0,
    }) {
        const translate = this.$filter('translate');
        const sendCount = feedbackAcceptedCount + feedbackPendingCount;
        const sendLabel = `${feedbackAcceptedCount}/${sendCount} ${translate('RECIEVED')}`;

        if (!feedbackStatusExist) {
            return `${allFeedBackWorkflows || 0} ${translate('ADDED')}`;
        }

        if (readyForSendFeedbackCount > 0) {
            return `${sendLabel} </br> ${readyForSendFeedbackCount} ${translate('ADDED')}`;
        }

        return sendLabel;
    }

    getFeedbackStepHref() {
        const { pathName, workflowStep } = this;

        return this.$state.href(pathName, {
            workflowStep,
            talentID: null,
            currCandidatePage: 1,
            feedbackFilterMode: null,
        });
    }
}

export const CandidateWorkflowFeedbackStepConfiguration = {
    template,
    bindings: {
        pathName: '<',
        isSelected: '<',
        counters: '<',
        onClick: '&',
    },
    controller: CandidateWorkflowFeedbackStep,
    controllerAs: 'candidateWorkflowFeedbackStepCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateWorkflowFeedbackStep', CandidateWorkflowFeedbackStepConfiguration);